// These are only examples, this can be updated...

const fonts = {

  size: {
    tiny: 10,
    small: 15,
    medium: 20,
    large: 23,
    xl: 26,
    xxl: 30,
  },
  weight: {
    tiny: '100',
    small: '200',
    medium: '300',
    large: '400',
    xl: '500',
    xxl: '600',
  },

}

export default fonts;



// WEBPACK FOOTER //
// ./src/theme/fonts.js